import { DEFAULT_LOCALE as P } from "../../constants/locale.js";
import { createStrictContext as x } from "../../util/context/createStrictContext.js";
import { underscoreLocale as C } from "../../util/i18n/helper/locale.js";
import { singleOperation as v } from "../../util/operation/singleOperation.js";
import { useRouter as y } from "next/router";
import * as t from "ramda";
import { useMemo as L, useState as K, useCallback as c } from "react";
import { jsx as _ } from "react/jsx-runtime";
const [h, g] = x("Preload"), j = (m) => {
  const {
    children: p
  } = m, {
    locale: a
  } = y(), s = L(() => C(a || P), [a]), [e, i] = K({}), n = c((r) => `preload_${r}_${s}`, [s]), u = c(async (r, d) => {
    const o = n(r);
    if (t.has(o, e))
      return t.prop(o, e);
    {
      const l = await v(o, d);
      return i((f) => t.assoc(o, l, f)), l;
    }
  }, [e, n]);
  return /* @__PURE__ */ _(h, {
    value: {
      preloadValue: u
    },
    children: p
  });
};
export {
  j as PreloadProvider,
  g as usePreloadContext
};
//# sourceMappingURL=PreloadContext.js.map
